import React from "react";
import TopBanner from "../components/banner/topBanner";
import { Banners } from "../components/data";
import MobileMain from "../components/blocks/mobileMain";

export default function Mobile() {
    return(
        <div className="Mobile">
            <TopBanner title={Banners[2].title} />
            <MobileMain />
        </div>
    )
}